import { render, staticRenderFns } from "./OfflineResult.vue?vue&type=template&id=ef67ef54&scoped=true"
import script from "./OfflineResult.vue?vue&type=script&lang=ts"
export * from "./OfflineResult.vue?vue&type=script&lang=ts"
import style0 from "./OfflineResult.vue?vue&type=style&index=0&id=ef67ef54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67ef54",
  null
  
)

export default component.exports